import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
function ChevronRightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "8 0 8 16",
    height: "16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.94 8l-5.47 5.47a.75.75 0 001.06 1.06l6-6a.75.75 0 000-1.06l-6-6a.75.75 0 00-1.06 1.06z",
    fill: "currentColor"
  }));
}
export default ChevronRightIcon;
//# sourceMappingURL=ChevronRightIcon.js.map